<template>
  <div>
    <el-dialog :title="Title" :before-close="handleClose" custom-class="dialog" :visible.sync="userSearchDialogVisible" width="60%" append-to-body top='2vh' :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form ref="form" :model="userForm" class="searchForm1" label-width="80px" size="small">
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="机构组织">
              <SelectInstitution :setWidth="setWidth" @getValue="getSelectInstitution" :idArray='idArrayInstitution' ref="institution"></SelectInstitution>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="岗位">
              <el-select clearable size="small" :multiple="true" default-first-option filterable :style="{width: setWidth}" v-model="userForm.valuePostId" :filter-method="filterMethod" placeholder="请选择岗位">
                <el-option v-for="(item, index) in options" :key="item.ID + index" :label="item.Name" :value="item.ID">
                  <span style="float: left">{{ item.Name }}</span>
                  <span style="float: right; color: #8492a6;padding-right: 20px;">{{ item.DeptName+' - '+item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="关键字">
              <el-input class="searchInput" value="demo" placeholder="请输入名称,简拼,手机号或者工号模糊查找" v-model="userForm.keyword"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="搜索范围">
              <el-checkbox-group v-model="userForm.checkList2" @change="rangeChange">
                <el-checkbox label="人员"></el-checkbox>
                <el-checkbox label="联系人"></el-checkbox>
                <!-- <el-checkbox label="联系人" v-if="IsContainContact"></el-checkbox> -->
                <!-- <el-checkbox label="微信注册" :disabled="IsContainPeop?true:false"></el-checkbox> -->
                <el-checkbox label="微信注册"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24" style="text-align: center;margin-top: 10px;">
            <el-button type="primary" size="medium" @click="doSearch">搜索</el-button>
            <el-button size="medium" @click="doClear" v-if="editMode === 0">清空</el-button>
            <el-button type="primary" size="medium" @click="createTemplate" v-if="editMode === 0">保存为模板</el-button>

            <el-button type="primary" size="medium" @click="saveTemplate" v-if="editMode === 1">保存</el-button>
            <el-button type="primary" size="medium" @click="saveAsTemplate" v-if="editMode === 1">另存为</el-button>
          </el-col>
        </el-row>
        <createTemplate ref="createTemplate" :body="false" :temType="0"></createTemplate>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import createTemplate from "../template/createTemplate.vue";
import 
{ 
  GetListPostInfo ,
  // GetTemplateUserSearchResult,
  // GetTemplateUserSearchResultCount
  GetNewEmergencyUserSearchResultCount
} from "@/api/modules/basicData/organization";
import { UpdateTemplate } from "@/api/modules/basicData/task";
import searchJs from "@/util/search";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
import { mapState } from "vuex";

export default {
  props: {
    IsContainContact: { //是否包含对联系人的搜索
      //查询方法
      type: Boolean,
      default: false
    }
  },
  components: {
    SelectInstitution: () => import("./SelectInstitution.vue"),
    createTemplate
  },
  data() {
    return {
      userForm:{
        selectInstitutionList:[],
        valuePostId:[],
        keyword:"demo",
        checkList2:["人员","联系人","微信注册"]
      },
      Title: "搜索",
      setWidth: "100%",
      userId: cookieUser.userId,
      userSearchDialogVisible: false,
      keyword:'',
      category:6,//人员

      checkList2:["人员","联系人","微信注册"],
      optionsCache:[],//岗位数据源
      options: [],  //岗位下拉列表数据源
      valuePostId: [], //岗位选中数据

      selectInstitutionList:[],//选中的机构组织
      idArrayInstitution:[],

      listResult:[],//返回结果集合
      editMode:0,//0：默认 1：编辑模板
      editModel:null,//待修改的PUB_TEMPLATE实体
      queryData:{  //分页请求参数
        Para:"",
        Pageindex: 1,  //0表示第一页
        PageSize:10
      },
      IsContainPeop:false  // 检测是否包含人员
    };
  },
  
  methods: {
    rangeChange(val){  //选中之后的值
      console.log("选择范围:",val);
      // this.checkList2=val;
      if(val.includes('人员')){
        this.IsContainPeop=false;
      }else{
        this.IsContainPeop=true;
      }
    },
    handleClose(done) {
        this.$emit('searchDialogClosed');
        done();
    },
    doSearch(){  //执行搜索
      let param = this.getPara();
      console.log(param);
      
      if(!param){  //搜索条件错误
          return;
      }
      console.log("param is:",param);
      this.queryData.Para=JSON.stringify(param);
      console.log(' this.queryData.Para=>>',  this.queryData.Para)
      this.$emit("getSearParm",this.queryData.Para);

      GetNewEmergencyUserSearchResultCount({ ...this.queryData, OpUserId :cookieUser.userId }).then(res=>{
        console.log("doSearch执行搜索:",res);
        
          // res.forEach(s=>{
          //     s.Key = s.Type+"_"+s.ID;
          // })
          this.listResult = res.ResultData;
          this.userSearchDialogVisible = false;
          if(res.ResultCount > 0){
            this.$emit("pageviseable",true);
          }
          this.$emit("getTotal",res.ResultCount);
          this.$emit("search",this.listResult);
          this.$emit('searchDialogClosed');
      }).catch(err=>{
          console.log("GetTemplateUserSearchResultCount err",err);
      })
      console.log("the search end ...");
    },
    getPara() {
      let para = {};
      para.CurrentUserId = cookieUser.userId;
      para.Keyword = this.userForm.keyword;
      para.ListCompanyDept = this.transCompanyDept(this.userForm.selectInstitutionList);
      para.ListPostId = this.userForm.valuePostId;
      // para.IsContainContact = this.IsContainContact;
      para.SearchRange = this.transCheckList(this.userForm.checkList2);
      console.log("para is:",para);
      return para;
    },
    transCheckList(checkList){
      if(checkList && checkList.length>0){
        if(checkList.includes('人员') && checkList.includes('联系人') && checkList.includes('微信注册'))
            return 0;
        else if(checkList.includes('联系人') && checkList.includes('微信注册'))
            return 5;
        else if(checkList.includes('人员') && checkList.includes('微信注册'))
            return 4;
        else if(checkList.includes('人员') && checkList.includes('联系人'))
            return 6;
        else if(checkList.includes('联系人'))
            return 2;
        else if(checkList.includes('微信注册'))
            return 3;
        else if(checkList.includes('人员') )
            return 1;
      }
      return 0;   //2默认返回全部
    },
    transCompanyDept(listCompanyDept){
      let ret = [];
      if(listCompanyDept){
        listCompanyDept.forEach(s=>{
            ret.push({CompanyId:s.CompanyId,CompanyName:s.CompanyName,DeptId:s.DeptId,DeptName:s.DeptName}); 
        })
      }
      return ret;
    },
    doClear(){
      this.reset(1);
    },
    getSelectInstitution(data){
        this.userForm.selectInstitutionList = data;
    },
    reset(tag = 0){  //0:重置所有数据，包括数据源  1：只清空填写与选择的结果    
      if(tag == 0)
          this.options = [];
      this.userForm.valuePostId = [];
      this.idArrayInstitution = [];
      this.userForm.keyword = "";

      this.editMode = 0;
      this.editModel = null;
      this.listResult=[];
      this.userForm.checkList2=[];
      // this.checkList2 = this.IsContainContact? ["人员","联系人"]:["人员","微信注册"];
    },
    async init(){  //初始化加载数据
        await GetListPostInfo().then(res=>{
          console.log("人员模板搜索，选择岗位接口:",res);
            this.options = res;
            this.optionsCache = res;
        })
    },
    // userSearchOpen(cond){
    //   console.log("编辑当前行:",cond,typeof(cond));
    //   this.userSearchDialogVisible = true;
    //   // let serPar=JSON.parse(cond);
    //   let serPar=cond;
    //   console.log(serPar);
    //   console.log(serPar.Keyword);
      
    //   this.keyword=serPar.Keyword;
    //   console.log(serPar.SearchRange);
      
    //   if(serPar.SearchRange == 2 ){
    //       this.checkList2 = ["人员","联系人"];
    //   }
    // },
    async SearchOpen(editData,tag=0) {
      //打开窗口界面
      // console.log("this.userForm.checkList2",this.userForm.checkList2);
      this.userSearchDialogVisible = true;
      this.reset(tag);
      await this.init();
      if(tag == 1){ //表示只带入搜索条件，但是非编辑
        if(editData){
          //界面字段赋值
          let param = JSON.parse(editData.CONTENT);
          if(param.SearchRange == 0 ){
            this.userForm.checkList2 = ["人员","联系人","微信注册"];
          }
          if(param.SearchRange == 1 ){
            this.userForm.checkList2 = ["人员"];
          }
          if(param.SearchRange == 2 ){
            this.userForm.checkList2 = ["联系人"];
          }
          if(param.SearchRange == 3 ){
            this.userForm.checkList2 = ["微信注册"];
          }
          if(param.SearchRange == 4 ){
            this.userForm.checkList2 = ["人员","微信注册"];
          }
          if(param.SearchRange == 5 ){
            this.userForm.checkList2 = ["联系人","微信注册"];
          }
          if(param.SearchRange == 6 ){
            this.userForm.checkList2 = ["联系人","人员"];
          }
          if(param.ListPostId ){
              this.userForm.valuePostId = param.ListPostId;
          }
          if(param.ListCompanyDept){
              let arrCompanyDeptId = [];
              for(let cdid of param.ListCompanyDept){
                if(cdid.DeptId){
                  arrCompanyDeptId.push(2+ '_'+cdid.DeptId);
                }
                else if(cdid.CompanyId){
                  arrCompanyDeptId.push(1+ '_'+cdid.CompanyId);
                } 
              }
              this.idArrayInstitution = arrCompanyDeptId;
          }
          this.userForm.keyword = param.Keyword;
        }
      }
      if(tag == 0){
        if(editData){  //编辑
            console.log("编辑搜索模板Obj:",editData);
            this.editMode = 1;
            let{...emodel} = editData;
            this.editModel = emodel;
            //界面字段赋值
            console.log(editData);
            
            let param = editData.CONTENT?JSON.parse(editData.CONTENT):editData;
            console.log("param:",param);

            if(param.SearchRange == 0 ){
            this.userForm.checkList2 = ["人员","联系人","微信注册"];
          }
          if(param.SearchRange == 1 ){
            this.userForm.checkList2 = ["人员"];
          }
          if(param.SearchRange == 2 ){
            this.userForm.checkList2 = ["联系人"];
          }
          if(param.SearchRange == 3 ){
            this.userForm.checkList2 = ["微信注册"];
          }
          if(param.SearchRange == 4 ){
            this.userForm.checkList2 = ["人员","微信注册"];
          }
          if(param.SearchRange == 5 ){
            this.userForm.checkList2 = ["联系人","微信注册"];
          }
          if(param.SearchRange == 6 ){
            this.userForm.checkList2 = ["联系人","人员"];
          }
            if(param.ListPostId ){
                this.userForm.valuePostId = param.ListPostId;
            }
            if(param.ListCompanyDept){
                let arrCompanyDeptId = [];
                for(let cdid of param.ListCompanyDept){
                  if(cdid.DeptId){
                    arrCompanyDeptId.push(2+ '_'+cdid.DeptId);
                  }
                  else if(cdid.CompanyId){
                    arrCompanyDeptId.push(1+ '_'+cdid.CompanyId);
                  } 
                }
                this.idArrayInstitution = arrCompanyDeptId;
            }
            this.userForm.keyword = param.Keyword;
        }
      }
    },
    createTemplate() {
      let templateVal = this.getPara();
      if(!templateVal){  //搜索条件错误
          return;
      }
      this.$refs.createTemplate.open();
      this.$refs.createTemplate.content = JSON.stringify(templateVal);
    },
    saveTemplate() {
      let templateVal = this.getPara();  
      let obj = this.editModel;
      obj.CONTENT = JSON.stringify(templateVal);
      UpdateTemplate(obj,this.category).then(res => {
        console.log("UpdateTemplate res，",res);
        console.log(this.$parent);
        this.userSearchDialogVisible = false;

        this.$emit('searchDialogClosed');
      });
    },
    saveAsTemplate(){
      this.createTemplate();
    },
    filterMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          query = query.toLowerCase();
          this.options = this.postList.filter(item => {
            return (
              item.Name.toLowerCase().indexOf(query) > -1 ||
              item.PY.toLowerCase().indexOf(query) > -1 ||
              item.FullPY.toLowerCase().indexOf(query) > -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
  }
};
</script>

<style  scoped>
  .line {
    border: 0px solid red;
  }
  hr {
    margin: 0px;
    padding: 0px;
    margin-bottom: 5px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 8px;
  }
  .el-select {
    width: 100%;
  }
  .el-radio {
    margin-right: 15px;
  }
  .checkCreateExec >>> .el-checkbox-group {
    margin-top: 6px;
    margin-left: 20px;
  }
</style>
